$(document).ready(function () {
    if ($('.help-us__carousel').length) {
        $('.help-us__carousel').slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            speed: 700,
            // autoplay: true,
            autoplaySpeed: 7000,
            variableWidth: true,
            infinite: true,
            prevArrow: '<button type="button" class="slick-prev"><img src="/wp-content/themes/split_juegaterapia/assets/img/icons/left.svg"></button>',
            nextArrow: '<button type="button" class="slick-next"><img src="/wp-content/themes/split_juegaterapia/assets/img/icons/right.svg"></button>',
            responsive: [{
                breakpoint: 769,
                settings: {
                    slidesToShow: 1,
                    dots: true,
                    arrows: false
                }
            },
                {
                    breakpoint: 577,
                    settings: {
                        slidesToShow: 1,
                        // variableWidth: false,
                        dots: true,
                        arrows: false
                    }
                }
            ]
        });
    }
});